import * as utils from '@0x/protocol-utils'

export { utils }
export const NULL_ADDRESS = '0x0000000000000000000000000000000000000000'
